module.exports = __webpack_public_path__ + "static/img/qrcodeslg.06ad230.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/qrcodeslg.png
// module id = X7PR
// module chunks = 1